export const faqs = [
  {
    id: "faq-1",
    question: "咨询是匿名的吗？我的隐私如何保障？",
    answer: "是的，所有咨询服务都严格遵循保密原则。我们采用端到端加密的通讯方式，您无需提供真实姓名即可进行咨询。咨询记录仅咨询师本人可见，未经您的书面授权，绝不会向任何第三方透露。您的隐私和安全是我们的首要承诺。",
  },
  {
    id: "faq-2",
    question: "线上咨询和线下面对面咨询效果一样吗？",
    answer: "大量研究表明，线上心理咨询在大多数情况下与线下咨询同样有效，尤其在性健康领域，线上咨询的「距离感」反而能让来访者更放松地谈论敏感话题。我们的线上咨询提供视频、语音和文字三种方式，您可以根据自己的舒适度选择。",
  },
  {
    id: "faq-3",
    question: "我需要做多少次咨询才能看到效果？",
    answer: "每个人的情况不同，改善的节奏也因人而异。一些具体的问题（如表现焦虑的基础应对策略）可能在3-5次咨询后就有明显改善；而深层的关系问题或心理创伤则需要更长的时间投入。在首次评估后，咨询师会为您制定个性化的咨询计划，并定期回顾进展。",
  },
  {
    id: "faq-4",
    question: "可以带伴侣一起咨询吗？",
    answer: "当然可以！实际上，对于许多亲密关系和性功能问题，伴侣的参与能够显著提升咨询效果。我们提供伴侣联合咨询的选项。如果您担心伴侣不理解或不配合，咨询师也可以在个别咨询中帮助您制定与伴侣沟通的策略。",
  },
  {
    id: "faq-5",
    question: "咨询顾问都有哪些资质？",
    answer: "我们所有的咨询顾问均持有国家认可的心理咨询师、性治疗师或相关医学专业的执业资质，并具有至少5年以上的临床经验。每位顾问都经过严格的背景审核和定期的专业培训，确保为您提供科学、专业、安全的咨询服务。",
  },
  {
    id: "faq-6",
    question: "如果不满意服务，可以退款或更换顾问吗？",
    answer: "我们理解找到「对的人」对咨询效果至关重要。如果您对当前的咨询师不满意，可以随时申请更换顾问。我们也提供首次咨询后的无条件退款保障，确保您能够在零风险的情况下体验我们的服务。",
  },
  {
    id: "faq-7",
    question: "咨询费用是多少？可以使用医疗保险吗？",
    answer: "我们的咨询服务提供多种套餐选择，单次咨询费用根据顾问资历在300-800元之间，套餐购买可享受优惠。目前国内的医疗保险暂不支持心理咨询类服务报销。我们定期推出公益咨询时段，为经济困难群体提供低成本的咨询选择。",
  },
];